import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ProfileService } from '../profile/profile.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-notes-settings',
  templateUrl: './notes-settings.component.html',
  styleUrls: ['./notes-settings.component.css']
})
export class NotesSettingsComponent implements OnInit {
  currentUser:any;
  constructor(
    private _toastr:ToastrService,
    private _location: Location,
    private _profileService: ProfileService,
    private _authService: AuthService,
    
  ) { 
    const currentUser = this._authService.currentUser;
    if(currentUser) {
      this.currentUser = currentUser;

    }

  }

  ngOnInit(): void {
  }


  getNonPccFacEmail(){
    //console.log("this.currentUser?.other_settings",this.currentUser?.other_settings);
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.non_pcc_email
    }
    else{
      return false
    }
  }
  getPccFacEmail(){
    //console.log("this.currentUser?.other_settings",this.currentUser?.other_settings);
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.pcc_email
    }
    else{
      return false
    }
  }
  changeNonPccFacEmailStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.non_pcc_email = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          non_pcc_email: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changePccFacEmailStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.pcc_email = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          pcc_email: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }


}
